
import CarouselGeneric from './types/generic';
import CarouselBlogCards from './types/blog-cards';
import CarouselContent from './types/content';
import CarouselHero from './types/hero';
import CarouselPlans from './types/plans';
import CarouselFeatureCards from './types/feature-cards';

export default class Carousels {

  setup(scope) {
    new CarouselGeneric(scope);
    new CarouselBlogCards(scope);
    new CarouselContent(scope);
    new CarouselHero(scope);
    new CarouselPlans(scope);
    new CarouselFeatureCards(scope);
  }

  start() {
    this.setup(document);
  }
}
